var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Icon from '../../../../components/Icon';
import translate from '../../../../lib/utils/translate';
import Select from '../../../../components/Select';

var AccountSelection = function (_Component) {
  _inherits(AccountSelection, _Component);

  function AccountSelection() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AccountSelection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AccountSelection.__proto__ || Object.getPrototypeOf(AccountSelection)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
      var selectedAccount = _this.props.accounts.find(function (acc) {
        return acc.accountId === e.target.value;
      }) || {};
      _this.props.onChange(selectedAccount);
    }, _this.maskCreditCardNumber = function (num) {
      return '**** **** **** ' + num.substring(num.length - 4);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AccountSelection, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          accounts = _props.accounts,
          intl = _props.intl,
          selectedAccount = _props.selectedAccount,
          canAddAccount = _props.canAddAccount;


      var accountOptions = accounts.map(function (account) {
        return React.createElement(
          Select.Option,
          { value: account.accountId, key: account.accountId },
          account.type === 'creditcard' ? _this2.maskCreditCardNumber(account.maskedAccount) : account.maskedAccount
        );
      });
      if (Boolean(canAddAccount)) {
        accountOptions.push(React.createElement(
          Select.Option,
          { value: 'new-account' },
          translate({
            id: 'action.cashier.add-new-account',
            defaultMessage: 'Add new account'
          }, intl)
        ));
      }

      var icon = null;

      if (selectedAccount.type === 'creditcard') {
        icon = 'cc-' + selectedAccount.cardType.toLowerCase();
      } else if (!selectedAccount.accountId) {
        icon = 'plus';
      }

      return React.createElement(
        'div',
        { className: 'account-selection' },
        React.createElement(
          Select,
          {
            value: selectedAccount.accountId || 'new-account',
            onChange: this.handleChange,
            icon: icon ? React.createElement(Icon, { icon: icon }) : null },
          accountOptions
        )
      );
    }
  }]);

  return AccountSelection;
}(Component);

export default injectIntl(AccountSelection);